import { computed } from "vue";
import { useStore } from "vuex";
import { theme as defaultTheme } from "@/scss/_theme.js";
import { bobbieTheme } from "@/scss/_theme-bobbie.js";

/**
 * Composable that returns the active theme based on Bobbie context.
 * For Bobbie customers (isBobbieContext), returns Bobbie-branded colors;
 * otherwise returns the default Airteam theme.
 */
export function useTheme() {
  const store = useStore();

  const theme = computed(() => {
    const isBobbie = store.state.auth?.isBobbieContext || false;
    return isBobbie ? bobbieTheme : defaultTheme;
  });

  return { theme };
}
